import { useState } from 'react'
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { Pagination, Select, Tag } from 'antd'
import { useDebouncedValue } from '@/hooks/use-debounced-value.ts'
import { useTRPC } from '@/trpc/react.ts'

export function RoleSelect({
  value = [],
  onChange,
  disabled
}: {
  value?: string[]
  onChange?: (ids: string[]) => void
  disabled?: boolean
}) {
  const trpc = useTRPC()
  const [keyword, setKeyword] = useState('')
  const [current, setCurrent] = useState(1)
  const search = useDebouncedValue(keyword.trim() || undefined)
  const query = useQuery({
    ...trpc.authorization.roleOptions.queryOptions({ current, pageSize: 20, keyword: search, selectedIds: value }),
    placeholderData: keepPreviousData
  })
  const options = new Map([...(query.data?.selected ?? []), ...(query.data?.data ?? [])].map((role) => [role.id, role]))
  return (
    <Select
      mode="multiple"
      value={value}
      onChange={onChange}
      disabled={disabled}
      allowClear
      showSearch={{
        filterOption: false,
        onSearch: (next) => {
          setKeyword(next)
          setCurrent(1)
        }
      }}
      loading={query.isFetching}
      options={[...options.values()].map((role) => ({
        value: role.id,
        disabled: !role.isEnabled,
        label: (
          <span>
            {role.name}
            {role.isProtected && (
              <Tag color="gold" className="ml-1">
                超级管理员
              </Tag>
            )}
            {!role.isEnabled && '（停用）'}
          </span>
        )
      }))}
      notFoundContent={query.isError ? query.error.message : undefined}
      placeholder="搜索并选择角色"
      popupRender={(menu) => {
        if ((query.data?.total ?? 0) <= 20) return menu

        return (
          <>
            {menu}
            <div className="border-border-muted border-t p-2">
              <Pagination
                size="small"
                simple
                current={current}
                pageSize={20}
                total={query.data?.total ?? 0}
                onChange={setCurrent}
              />
            </div>
          </>
        )
      }}
    />
  )
}
